import { authApi } from './authApi';
import { CityResponse } from '../types/city';

/**
 * Obtém a lista de todas as cidades (Connect).
 * GET /cities/
 */
export const getCities = async (): Promise<CityResponse[]> => {
  const response = await authApi.get<CityResponse[]>('/cities/');
  return response.data;
};
